import { render, staticRenderFns } from "./c_menu_list.vue?vue&type=template&id=28b9fb81&scoped=true"
import script from "./c_menu_list.vue?vue&type=script&lang=js"
export * from "./c_menu_list.vue?vue&type=script&lang=js"
import style0 from "./c_menu_list.vue?vue&type=style&index=0&id=28b9fb81&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b9fb81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b9fb81')) {
      api.createRecord('28b9fb81', component.options)
    } else {
      api.reload('28b9fb81', component.options)
    }
    module.hot.accept("./c_menu_list.vue?vue&type=template&id=28b9fb81&scoped=true", function () {
      api.rerender('28b9fb81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PageDiy/mobileConfigRight/c_menu_list.vue"
export default component.exports